module.exports = __webpack_public_path__ + "static/media/pasta_70_gr.db5bee81.png";